namespace GeniuzPOS.InitialData {
    export class PsCorperateMessageRecieptColumns {
        static columnsKey = 'InitialData.PsCorperateMessageReciept';
    }
}
